import axios from "@/libs/api.request";
export const getZajiMapping = params => {
  return axios.request({
    url: "/common/zajilCityMapping",
    method: "GET",
    params
  });
};

export const getAgentCityMapping = params => {
  return axios.request({
    url: "/common/agentCityMapping",
    method: "GET",
    params
  });
};

export const removeCityMapping = id => {
  return axios.request({
    url: `/common/removeCityMapping/${id}`,
    method: "DELETE"
  });
};

export const updateCityMapping = data => {
  return axios.request({
    url: `/common/updateCityMapping/${data.id}`,
    method: "PUT",
    data
  });
};

export const getCityMappingConfig = () => {
  return axios.request({
    url: "/common/cityMappingConifg",
    method: "GET"
  });
}

export const batchUploadCity = data => {
  return axios.request({
    url: "/common/batchUploadCity",
    method: "POST",
    data
  });
}

export const getDetails = id => {
  return axios.request({
    url: `/common/zajilCityMapping/${id}`,
    method: "GET"
  });
};
export const del = id => {
  return axios.request({
    url: `/common/zajilCityMapping/${id}`,
    method: "DELETE"
  });
};
export const update = data => {
  return axios.request({
    url: `/common/zajilCityMapping/${data.id}`,
    method: "PUT",
    data
  });
};
export const add = data => {
  return axios.request({
    url: "/common/zajilCityMapping",
    method: "POST",
    data
  });
};
